import * as OvationsApi from 'core/ovations-api';

import { mockImageRotatorImage, mockImageRotatorImages } from './imageRotatorImage';

export const mockPortalDashboard: OvationsApi.Types.PortalDashboard = {
    programId: '__programId__',
    imageRotatorTitle: 'title',
    imageRotatorImages: [mockImageRotatorImage],
    enablePointTracker: false,
    pointTrackerTitle: '__pointTrackerTitle__',
    pointTrackerGoal: 12345,
    allowedPointTrackerRoles: [],
    enableYearOverYearTracker: false,
    yearOverYearTrackerTitle: '__yearOverYearTitle__',
    yearOverYearTrackerGoal: 12345,
    yearOverYearTrackerUnits: '__yearOverYearUnit__',
    allowedYearOverYearTrackerRoles: [],
    trackerBackgroundFileLocation: null,
    trackerBackgroundUrl: null,
    trackerIcon: null,
    useEnglishImageRotatorImages: false,
};

export const mockPortalDashboardWithMultipleImages: OvationsApi.Types.PortalDashboard = {
    ...mockPortalDashboard,
    imageRotatorImages: mockImageRotatorImages,
};

export default mockPortalDashboard;
